import { render, staticRenderFns } from "./InfoField.vue?vue&type=template&id=a2c951d4&scoped=true"
import script from "./InfoField.vue?vue&type=script&lang=js"
export * from "./InfoField.vue?vue&type=script&lang=js"
import style0 from "./InfoField.vue?vue&type=style&index=0&id=a2c951d4&prod&scoped=true&lang=css"
import style1 from "./InfoField.vue?vue&type=style&index=1&id=a2c951d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c951d4",
  null
  
)

export default component.exports